import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <div className="footer">
       <p>Powered by <a href="http://translate.yandex.com/" target="_blank" rel="noopener noreferrer" >Yandex.Translate↗</a>&emsp;·&emsp;View on <a href="https://github.com/thelittlewonder/whatsthat" target="_blank" rel="noopener noreferrer">GitHub↗</a>&emsp;·&emsp;By <a href="https://twitter.com/lilwonderspeaks" target="_blank" rel="noopener noreferrer">thelittlewonder</a></p>
      </div>
    );
  }
}

export default Footer;
